<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Lone Star</h1>
<h2 class="subtitle">A History of Texas and the Texans</h2>
<p class="author">T. R. Fehrenbach</p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?c8ecb3ca